var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.formatCurrency(_vm.price, _vm.currency))+" "+_vm._s(_vm.convertChargingCycle(_vm.chargingCycle))+" "),(_vm.chargingCycle)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.chargingCycleSubscription)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }